import Vue from 'vue'

Vue.filter('removeHtml', function (value) {
    if (!value) {
        return ''
    }
    let tmp = document.createElement("DIV");
    tmp.innerHTML = value;
    return  tmp.textContent || tmp.innerText || "";
});

Vue.filter('truncate', function (value) {
    if (!value) {
        return ''
    }
    let tmp = value.substring(0, 60);
    if (value.length > 60) {
        tmp += "...";
    }
    return tmp;
});
Vue.filter('truncate140', function(value) {
    if (!value) {
        return ''
    }
    let tmp = value.substring(0, 140);
    if (value.length > 140) {
        tmp += "...";
    }
    return tmp;
})
Vue.filter('truncate20', function (value) {
    if (!value) {
        return ''
    }
    let tmp = value.substring(0, 20);
    if (value.length > 20) {
        tmp = tmp.trim() + "...";
    }
    return tmp;
});
Vue.filter('truncate20', function (value) {
    if (!value) {
        return ''
    }
    let tmp = value.substring(0, 20);
    if (value.length > 20) {
        tmp = tmp.trim() + "...";
    }
    return tmp;
});
Vue.filter('truncate30', function (value) {
    let tmp = value.substring(0, 30);
    return tmp;
});

Vue.filter('nl2br', function(value) {
    return value.replace(/(\r\n|\n\r|\r|\n)/g, '<br/>$1');
});

Vue.filter('capitalize', function(value) {
    value = value.toLowerCase();
    return value.charAt(0).toUpperCase() + value.slice(1)
});

Vue.filter('lowercase', function(value) {
    return value.toLowerCase();
})
